import React, { useRef } from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip, Badge } from "reactstrap";

import { none as pointerEventsNone } from "stylesheets/utilities/pointerEvents.module.scss";

const BadgeWithTooltip = ({ name, children, placement, color, className }) => {
  const tooltipRef = useRef(null);

  return (
    <>
      <Badge className={className} color={color} innerRef={tooltipRef}>
        {name}
      </Badge>
      <UncontrolledTooltip
        popperClassName={pointerEventsNone}
        placement={placement}
        target={tooltipRef}
      >
        {children}
      </UncontrolledTooltip>
    </>
  );
};

BadgeWithTooltip.propTypes = {
  /**
   * Text to be displayed within the Badge
   */
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * See Reactstrap documentation for available placements, defaults to top
   */
  placement: PropTypes.string,
  /**
   * Attach a class directly to the tooltip
   */
  tooltipClassName: PropTypes.string,
  /**
   * See Reactstrap Badge documentation for available colors, defaults to success (green)
   */
  color: PropTypes.string,
  /**
   * Attach a class directly to the Badge
   */
  className: PropTypes.string
};

BadgeWithTooltip.defaultProps = {
  color: "success",
  placement: "top"
};

export default BadgeWithTooltip;
